import { Button, Stack, Typography } from "@mui/material";
import { colours } from "../../../StyleConstants";
import LassoModal from "../../../components/LassoModal";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import { useNavigate } from "react-router-dom";
import React from "react";


const PiModal = (props: any) => {

    const navigate = useNavigate()

    // For AIAN, the application type is locked to whatever the PI's Approved General DUC is:
    // an individual General DUC can only lead to an individual AIAN, and a group General DUC can
    // only lead to a group AIAN. `requiredIsGroup` is only passed in (and only meaningful) for
    // type === "AIAN"; GENERAL's own modal is unaffected and still offers both options.
    const isAianTypeLocked = props.type === "AIAN" && typeof props.requiredIsGroup === "boolean"
    const showIndividualOption = !isAianTypeLocked || props.requiredIsGroup === false
    const showGroupOption = !isAianTypeLocked || props.requiredIsGroup === true

    const handleClickIndividual = (type: string) => {
        localStorage.setItem('formType', type)
        localStorage.setItem('isGroup', "false")
        localStorage.setItem('AddSub', JSON.stringify(false))
        navigate( "/duc/request");
    }
    const handleClickGroup = (type: string) => {
        localStorage.setItem('formType', type)
        localStorage.setItem('isGroup', "true")
        localStorage.setItem('AddSub', "false")
        navigate( "/duc/request");
    }

    return (
        <LassoModal open={props.open}>
            <Stack gap={4} padding="10px">
                <Stack flexDirection="row" justifyContent="space-between">
                    <Typography variant="h5" fontWeight="600" color={colours.midnightBlue.blue}>
                        Access Request Type
                    </Typography>
                    <HighlightOffIcon onClick={() => {props.setOpen(false)}}/>
                </Stack>
                <Stack gap={1}>
                    {props.type !== "AIAN" &&
                        <Typography color={colours.midnightBlue.blue}>
                            Choose between the two Data Use Certification (DUC) options below:
                        </Typography>
                    }
                    {showIndividualOption &&
                        <Typography color={colours.midnightBlue.blue}>
                            <strong>Individual DUC</strong>: Request access for yourself only.
                        </Typography>
                    }
                    {showGroupOption &&
                        <Typography color={colours.midnightBlue.blue}>
                            <strong>Investigator-Led Group DUC</strong>: You are a research investigator requesting access for yourself and any number of additional people in your group
                        </Typography>
                    }
                    {isAianTypeLocked &&
                        <Typography fontSize="13px" color={colours.midnightBlue.blue}>
                            Your A-DUC application type must match your approved General DUC, which is {props.requiredIsGroup ? "a group" : "an individual"} application.
                        </Typography>
                    }
                </Stack>

                <Stack flexDirection="row" alignSelf="center" gap={2}>
                    {showIndividualOption &&
                        <Button
                            id="duc-individual-button"
                            variant="primary"
                            startIcon={<PersonOutlineOutlinedIcon/>}
                            onClick={() => handleClickIndividual(props.type)}
                        >
                            Individual DUC
                        </Button>
                    }
                    {showGroupOption &&
                        <Button
                            id="duc-investigator-led-group-button"
                            variant="secondary"
                            startIcon={<PeopleOutlineOutlinedIcon/>}
                            onClick={() => handleClickGroup(props.type)}
                        >
                            Investigator-Led Group DUC
                        </Button>
                    }
                </Stack>

            </Stack>
        </LassoModal>
    )
}

export default PiModal